import io  from 'socket.io-client'
import { socketUrl } from '../helpers';
export const initalize = () => {

    const socket=io(socketUrl,{
        transports: ["websocket"],
        reconnection: true,
        reconnectionAttempts: 10,
        reconnectionDelay: 1000,
        path: "/socket.io/"
      });
    return socket; 
}
// export const socket=io("http://localhost:8000");